"use strict";
require.context("../../images", true);
import "src/decidim/global_adjustments";
